module.exports = "images/cc4cd6a5503408f900fa52517bf5cbf6.webp";